var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Alert',{attrs:{"show-icon":""}},[_vm._v("\n  未激活/激活失效\n  "),_c('Icon',{attrs:{"slot":"icon","type":"ios-bulb-outline"},slot:"icon"}),_c('template',{slot:"desc"},[_vm._v("请联系管理员激活")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }